/* eslint-disable jsdoc/require-jsdoc */
import type { AxiosInstance } from 'axios';
import axios from 'axios';
import Config from '@/config';
import { app } from '@/store';
/**
 *
 */
export const baseApi = {
  axiosInstance(): AxiosInstance {
    const baseUrl = Config.getSetting('baseURL');

    const settings = {
      baseURL: baseUrl,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      withCredentials: true,
    };

    return axios.create(settings);
  },

  request(method: any, path: any, params?: any): any {
    if (app && !(app as any).$store.getters['sidebar/getIsCallingApi']) {
      (app as any).$store.commit('sidebar/SET_IS_CALLING_API', true);
    }
    return new Promise(async (resolve, reject) => {
      try {
        params = params ?? {}
        params['headers'] = params['headers'] ?? {}
        const gemSession = (app as any).$store.getters['app/gemSession'];
        params['headers']['Gem-Session'] = gemSession;
        const { data } = await this.axiosInstance().request({ ...params, url: path, method });
        (app as any).$store.commit('sidebar/SET_IS_CALLING_API', false);
        resolve(data);
      } catch (e) {
        (app as any).$store.commit('sidebar/SET_IS_CALLING_API', false);
        reject(e);
      }
    });
  },

  get(path: string, params?: {}): any {
    return this.request('get', path, params);
  },

  post(path: string, params?: {}): any {
    return this.request('post', path, { data: params });
  },

  patch(path: string, params?: {}): any {
    return this.request('patch', path, { data: params });
  },

  delete(path: string, params?: {}): any {
    return this.request('delete', path, { data: params });
  },
};
